import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {ShipmentInfo} from '../../models/shipment-info.model';
import {KorrekturButtonCellComponentComponent} from '../sendungskorrektur/korrektur/korrektur-button-cell-component/korrektur-button-cell-component.component';
import {RadioaktivCellComponent} from './radioaktiv-cell/radioaktiv-cell.component';
import {FormService} from '../../services/form.service';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../locale.de';
import {InfoCellComponent} from './info-cell/info-cell.component';
import {ColliEvent, Dienst, DispoDetails, Gefahrgut, Sendungsereignisse} from '../../models';
import { ColliUbersicht } from '../../models/colliubersichtModel';

@Component({
  selector: 'lib-shipment-info-details',
  templateUrl: './shipment-info-details.component.html',
  styleUrls: ['./shipment-info-details.component.css']
})

export class ShipmentInfoDetailsComponent implements OnInit, OnChanges {
// All Modules with property binding
 colliData : ColliEvent[];
 dangerousGoodsData : Gefahrgut[];
 dispoDetailsData: DispoDetails[];
 sendungsereignisseData: Sendungsereignisse[];
 sendungsketteData: ShipmentInfo[];
 colliUbersichtData:ColliUbersicht[];

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;
  public isCollapsed: boolean = true;

  public locale = AG_GRID_LOCALE_DE;
  public overlayLoadingTemplate;

  public carretUp = faCaretUp;
  public carretDown = faCaretDown;
  public show: boolean;

  @Input() dienste: Dienst;
  @Input() shipmentInfoDetails: ShipmentInfo[];
  @Output() sendCorrectedValues = new EventEmitter<any>();
  @Input() colliEvent : ColliEvent[];
  @Input() sendungsereignisse: Sendungsereignisse[];
  @Input() dangerous_goods: Gefahrgut[];
  @Input() sendungskette: ShipmentInfo[];
  @Input() dispoDetails: DispoDetails[];
  @Input() colliUbersicht: ColliUbersicht[];

  constructor(private formService: FormService) {
    this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Sendungsdaten werden geladen...</span>';
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true,
      cellClass: 'locked-col'
    };

    this.columnDef = [
      {
        field: 'bcvsnr',
        headerName: 'BCV',
      },
      {
        field: 'absender',
        headerName: 'Name',
      },
      {
        headerName: 'Hinweise',
        cellRendererFramework: InfoCellComponent,
      },
      {
        field: 'sendungsnr',
        headerName: 'Sendungsnr',
      },
      {
        field: 'langreferenz',
        headerName: 'RefNr',
      },
      {
        field: 'erfassungstag',
        headerName: 'Ü-Datum',
      },
      {
        field: 'gesamtgewicht',
        headerName: 'Kg',
        maxWidth: 100
      },
      {
        field: 'colli',
        headerName: 'Col/Pal',
        minWidth: 100,
        valueGetter: this.getColAndPal
      },
      {
        headerName: 'Dienste',
        valueGetter: this.showDienste,
      },
      {
        headerName: 'Radioaktiv',
        cellStyle: {textAlign: 'center'},
        cellRendererFramework: RadioaktivCellComponent
      },
      {
        headerName: '',
        cellRendererFramework: KorrekturButtonCellComponentComponent,
        maxWidth: 60
      },
    ];
  }

  ngOnInit(): void {
    this.formService.submittedForm.subscribe((correctedValueForm => {
      if (correctedValueForm !== null) {
        this.sendCorrectedValues.emit(correctedValueForm);
        this.gridApi.showLoadingOverlay();
        this.formService.submittedForm.next(null);
      }
    }));
    this.formService.shipmentInfo.next(this.shipmentInfoDetails);

    setTimeout(() => {
      this.setData();
    }, 3000);
  }

  setData() {
    this.formService.setDienste(this.dienste);
    this.gridApi.setRowData(this.shipmentInfoDetails);
  }

  ngOnChanges() {
    if (this.shipmentInfoDetails.length > 0) {
      setTimeout(() => {
        this.gridApi.setRowData(this.shipmentInfoDetails);
        this.gridApi.hideOverlay();
      }, 3000);
    }
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getColAndPal(params: any) {
    const colli = params.data.colli;
    const paletten = params.data.paletten;
    return colli + '/' + paletten;
  }

  showDienste(param: any) {
    const dienste = [];
    param.data?.dienste?.map((dienst: Dienst) => {
      if (dienst.anzeigeKuerzel !== null) {
        dienste.push(dienst.anzeigeKuerzel);
      }
    });
    return dienste.join(', ');
  }

  toggleCollapse(): void {
    this.formService.setDienste(this.dienste);
    this.isCollapsed = !this.isCollapsed;
    this.show = !this.show;
    this.gridApi.setRowData(this.shipmentInfoDetails);
  }
}
